import { flags } from '@hopin-team/provider-feature-flag/dist/FeatureFlagContext';

import { State as EventDetails } from '../features/event-details/event-detail-types';
import { isQuickRegistrationEnabled } from './flags';
import { isClosed } from './tickets';

export const isFirstTicketClosed = (eventDetails: EventDetails) => {
  if (!eventDetails.tickets || !eventDetails.tickets.length) return false;

  const [firstTicket] = eventDetails.tickets;
  return isClosed(firstTicket, eventDetails);
};

export const isQuickRegistrationEligible = (
  eventDetails: EventDetails,
  flags: flags,
) => {
  return (
    !isFirstTicketClosed(eventDetails) &&
    eventDetails.settings.maxTicketsPerOrder === 1 &&
    eventDetails.tickets.length === 1 &&
    isQuickRegistrationEnabled(flags)
  );
};
